import axios from 'axios';
import { polusBaseUrl, POST } from '../../../utils/axios-interceptor';
import { orgScopedHeaders } from '../../../utils/constants/commonConstants';
import { getTimeStamp } from '../../../utils/dateUtils';

export function fetchRelatedPartyDataService(payload, { withRequestedOrg = false }: { withRequestedOrg?: boolean } = {}) {
    return axios({
        baseURL: polusBaseUrl,
        url: API_ENDPOINTS.FETCH_RELATED_PARTY_DATA,
        method: POST,
        ...(withRequestedOrg && { headers: orgScopedHeaders(payload.orgId) }),
        data: {
            requestPayload: {
                requestId: getTimeStamp(),
                name: 'AICA_VENDOR_SOURCE_MAP',
                ...payload,
            },
        },
    });
}

const API_ENDPOINTS = {
    FETCH_RELATED_PARTY_DATA: '/unifier/getRelatedParties',
    FETCH_RELATED_PARTY_BANK_TRANSACTIONS: '/unifier/getRelatedPartyBankTransactions',
};

export async function fetchRelatedPartyBankTransactionsService(orgId: string, partyKey: string): Promise<unknown> {
    const response = await axios({
        baseURL: polusBaseUrl,
        url: API_ENDPOINTS.FETCH_RELATED_PARTY_BANK_TRANSACTIONS,
        method: POST,
        headers: orgScopedHeaders(orgId),
        data: { requestPayload: { requestId: getTimeStamp(), partyKey } },
    });
    return response?.data;
}
